import { RecursoFiltro } from 'app/entity/recurso-filtro.model';
import { Component } from '@angular/core';
import { BaseCrudComponent } from '../../base';
import { Validators } from '@angular/forms';
import { GerenciamentoCursoExterior } from '../../entity/gerenciamento-curso-exterior.model';
import { dataFimLimite } from 'app/util/custom.validators';
import { SelectItem } from 'primeng/primeng';

@Component({
    selector: 'gerenciamento-curso-exterior-crud',
    templateUrl: './crud.component.html'
})
export class GerenciamentoCursoExteriorCrudComponent extends BaseCrudComponent {
    hoje: Date = new Date();
    controllerName = 'gerenciamentoCursoExterior';
    gerenciamentoCursoExterior: GerenciamentoCursoExterior;
    listaTipoAtividade: any[] = [];
    listaModalidade: any[] = [];
    listaAreaTematica: any[] = [];
    listaPais: any[] = [];
    cpf: string;
    listaAnexo: any[] = [];
    isValid: boolean = false;
    validateForm: any;
    stepObject: any;
    listaResumo: any[];
    listaRelatores: SelectItem[] = [];
    listaPntCFC: any[];
    listaPntCRC: any[];
    mostrarCodigo: boolean = false;
    controladorGerenciamento = false;
    recursoFiltro: RecursoFiltro = new RecursoFiltro();

    setStepObject(obj: any) {
        this.stepObject = obj;
    }
    init() {
        this.cadastro = this.formBuilder.group({
            instituicao: [null, [Validators.required, Validators.maxLength(100)]],
            id_natureza: [null, [Validators.required]],
            titulo: [null, [Validators.required, Validators.maxLength(100)]],
            data_inicio: [null, [Validators.required]],
            data_fim: [null, [Validators.required]],
            carga_horaria: [null, [Validators.required, Validators.min(0)]],
            id_modalidade: [null, [Validators.required]],
            id_area_tematica: [null, [Validators.required]],
            id_pais: [null, [Validators.required]],
            programacao: [null, [Validators.maxLength(4000)]],
            observacao: [null, [Validators.maxLength(4000)]],
            id_situacao: [2],
            codigo: [null],
            cpf: [null],
            id: [null]
        });
        this.service.ListarTodos('modalidade').subscribe(data => {
            this.listaModalidade = data;
        });
        this.service.ListarTodos('areaTematica').subscribe(data => {
            this.listaAreaTematica = data;
        });
        this.service.ListarTodos('pais').subscribe(data => {
            this.listaPais = data;
        });

        this.cadastro.get('id_natureza').disable();
        if (this.acao == 'editar') {
            this.cadastro.get('data_fim').disable();
        }
    }
    carregarObj(event: any) {
        this.gerenciamentoCursoExterior = new GerenciamentoCursoExterior(this.cadastro.value, this.listaAnexo);
    }

    afterInit() {
        this.cadastro.get('data_fim').valueChanges.subscribe(x => {

            this.verificarPrestacaoForaDoPrazo(x, this.cadastro);

            this.observableUtilPanelDoc.setBlockedPanel(true);
            this.service.ListarTodos('natureza', { query: "Cursos no Exterior", data: this.cadastro.get('data_fim').value }).subscribe(data => {
                this.listaTipoAtividade = data;
                this.cadastro.get('id_natureza').enable();
                this.observableUtilPanelDoc.setBlockedPanel(false);
            });
        });
    }

    afterLoad() {
        this.mostrarCodigo = true;
        this.gerenciamentoCursoExterior = this.obj;
        if (this.obj.anexo_gerenciar_atividade != null) {
            this.obj.anexo_gerenciar_atividade.forEach(x => {
                x.show = true;
                this.listaAnexo.push(x);
            });
        }
        this.obj.homologacao_curso_exterior.map(item => {
            this.service.ListarRelatores('listaRelatoresHomologacao', { query: item.id }).subscribe(
                data => {
                    this.listaRelatores = data;
                  }
              );
            this.service.ListarTodos("resumoHomologacao", { query: item.id }).subscribe(
                data => {
                    this.listaResumo = data;
                }
            );
            this.service.ListarPontuacaoHomologacao("homologacao-curso-exterior", item.id, "Comissão CFC").subscribe(retorno => {
                this.listaPntCFC = retorno;
            });
            this.service.ListarPontuacaoHomologacao("homologacao-curso-exterior", item.id, "Comissão CRC").subscribe(retorno => {
                this.listaPntCRC = retorno;
            });
        });
    }

    finalizar(event: any) {
        this.gerenciamentoCursoExterior.id_lotacao = parseInt(localStorage.getItem('lotacao'));
        if (this.obj != null) {
            this.gerenciamentoCursoExterior.data_cadastro = this.obj.data_cadastro;
        }
        this.doFinalAction(this.gerenciamentoCursoExterior);
    }

}



// WEBPACK FOOTER //
// ./src/app/gerenciamento-curso-exterior/crud/crud.component.ts